// @unocss-include
import Layout from '@/components/layout/sider-menu-layout/index.vue';
import type { SiteRouteItem } from '@/router/types';
import { PermissionPageKey } from '@/types/permission';

const route: SiteRouteItem = {
  path: '/system',
  component: Layout,
  name: PermissionPageKey.System,
  meta: {
    title: '系统后台管理',
    roles: ['admin'],
    icon: 'ant-design:setting-filled',
    iconCls: 'bg-indigo-500',
  },
  redirect: '/system/user-management/user', // 默认首页子路由
  children: [
    {
      path: 'data-monitoring',
      name: PermissionPageKey.SystemDataMonitoring,
      meta: { title: '数据监控', icon: 'solar:chart-linear' },
      children: [
        {
          path: 'demand-ai',
          name: PermissionPageKey.SystemDataMonitoringDemandAi,
          component: () => import('../pages/data-monitoring/demand-ai/index.vue'),
          meta: { title: '需求文档 AI' },
        },
      ],
    },
    {
      path: 'user-management',
      name: PermissionPageKey.SystemUserManagement,
      meta: { title: '用户管理', icon: 'solar:user-linear' },
      children: [
        {
          path: 'user',
          name: PermissionPageKey.SystemUserManagementUser,
          component: () => import('../pages/user-management/user/index.vue'),
          meta: { title: '系统用户' },
        },
        {
          path: 'role',
          name: PermissionPageKey.SystemUserManagementRole,
          component: () => import('../pages/user-management/role/index.vue'),
          meta: { title: '角色管理' },
        },
        {
          path: 'collection',
          name: PermissionPageKey.SystemUserManagementCollection,
          component: () => import('../pages/user-management/collection/index.vue'),
          meta: { title: '用户集管理' },
        },
        {
          path: 'organization',
          name: PermissionPageKey.SystemUserManagementOrganization,
          component: () => import('../pages/user-management/organization/index.vue'),
          meta: { title: '组织管理' },
        },
      ],
    },
    {
      path: 'project-management',
      name: PermissionPageKey.SystemProjectManagement,
      meta: { title: '项目管理', icon: 'fa6-solid:diagram-project' },
      children: [
        {
          path: 'line',
          name: PermissionPageKey.SystemProjectManagementProductLine,
          component: () => import('../pages/project-management/product-line/index.vue'),
          meta: { title: '产品线' },
        },
        {
          path: 'series',
          name: PermissionPageKey.SystemProjectManagementSeries,
          component: () => import('../pages/project-management/series/index.vue'),
          meta: { title: '产品系列' },
        },
        {
          path: 'project',
          name: PermissionPageKey.SystemProjectManagementProject,
          component: () => import('../pages/project-management/project/index.vue'),
          meta: { title: '系统项目' },
        },
        {
          path: 'sort',
          name: PermissionPageKey.SystemProjectManagementProjectSort,
          component: () => import('../pages/project-management/project-sort/index.vue'),
          meta: { title: '项目排序' },
        },
      ],
    },
    {
      path: 'permission',
      name: PermissionPageKey.SystemPermissionManagement,
      meta: { title: '权限管理', icon: 'ant-design:lock-filled' },
      children: [
        {
          path: 'menu',
          name: PermissionPageKey.SystemPermissionManagementMenu,
          component: () => import('../pages/permission-management/menu/index.vue'),
          meta: { title: '菜单权限' },
        },
        {
          path: 'function',
          name: PermissionPageKey.SystemPermissionManagementFunction,
          component: () => import('../pages/permission-management/function/index.vue'),
          meta: { title: '功能权限' },
        },
      ],
    },
    {
      path: 'notification-management',
      name: PermissionPageKey.SystemNotificationManagement,
      component: () => import('../pages/notification-management/index.vue'),
      meta: { title: '通知管理', icon: 'ant-design:notification-filled' },
    },
    {
      path: 'ai-affairs',
      name: PermissionPageKey.SystemAiAffairs,
      meta: { title: 'AI 事项', icon: 'ant-design:robot-filled' },
      children: [
        {
          path: 'ai-work-item',
          name: PermissionPageKey.SystemAiWorkItem,
          component: () => import('../pages/ai-work-item/index.vue'),
          meta: { title: '工单审核' },
        },
        {
          path: 'robot-chat-audit',
          name: PermissionPageKey.SystemRobotChatAudit,
          component: () => import('../pages/robot-chat-audit/index.vue'),
          meta: { title: '机器人对话记录' },
        },
      ],
    },
    {
      path: 'tools',
      name: PermissionPageKey.SystemTools,
      meta: { title: '系统工具', icon: 'clarity:tools-solid' },
      children: [
        {
          path: 'models',
          name: PermissionPageKey.SystemToolModelManagement,
          component: () => import('../pages/tools/model-management/index.vue'),
          meta: { title: '模型管理' },
        },
        {
          path: 'clients',
          name: PermissionPageKey.SystemToolClientManagement,
          component: () => import('../pages/tools/client-management/index.vue'),
          meta: { title: '客户端管理' },
        },
      ],
    },
  ],
};

export default route;
